export enum ClientDiscountColumnLabels {
  ClientName = 'Client Name',
  Category = 'Category',
  Activity = 'Activity',
  Discount = 'Discount %'
}
